import { clsx } from 'shared/libs/style-merge'

import styles from './Divider.module.scss'

interface DividerProps {
  margin?: 'small' | 'medium' | 'large' | 'extra-large'
  type: 'horizontal' | 'vertical'
  className?: string
}

export function Divider({ margin = 'small', type, className }: DividerProps) {
  return (
    <div
      className={clsx(
        className,
        styles.divider,
        styles[type],
        styles[`${type}-${margin}`],
      )}
    />
  )
}
